/**
 * מידע נוסף ללקוח — מההקשר (חיפוש) או מההזמנה.
 * (מיפוי כמו ב־PackageOrderSummary)
 */
export function resolveCustomerQuoteAdditionalInfoHtml(order, selectedResult) {
  const fromContext = selectedResult?.clientRemarks;
  const fromOrder =
    order?.clientRemarks ??
    order?.client_remarks ??
    order?.client_remarks_html ??
    order?.search_result?.clientRemarks ??
    order?.deal?.clientRemarks;
  const pick = fromContext ?? fromOrder;
  if (pick == null || pick === "" || pick === 0) return "";
  return String(pick);
}
